import type { App } from "vue";
import { markRaw } from "vue";
import { facturaDesgloseGridsKey, type FacturaDesgloseGrids } from "@components/facturas/factura-desglose-injection";
import TramitesFacturaGrid from "@/components/mis-datos/TramitesFacturaGrid.vue";
import RappelsMensualesFacturaGrid from "@/components/mis-datos/RappelsMensualesFacturaGrid.vue";

/**
 * Contratos provide/inject a nivel aplicación.
 * Los modales se montan en ModalContainer (hermano del router), no bajo PrivateLayout;
 * por eso se usa app.provide aquí y no en el layout.
 */
export function registerPortalAppProvides(app: App): void {
  app.provide(
    facturaDesgloseGridsKey,
    markRaw<FacturaDesgloseGrids>({
      TramitesGrid: TramitesFacturaGrid,
      RappelsGrid: RappelsMensualesFacturaGrid,
    }),
  );
}
